import { useRef, useState } from 'react'
import { LuBell, LuSettings } from 'react-icons/lu'

import { useAlertStore } from '@/feature/alerts/store'

import { useClickOutside } from '@/lib/core/hooks/useClickOutside'

import styles from './AlertNavPopout.module.css'

export const AlertNavPopout = () => {
  const [isOpen, setIsOpen] = useState(false)
  const popoutRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { openManageAlerts } = useAlertStore()

  useClickOutside([popoutRef, buttonRef], () => setIsOpen(false), isOpen)

  const handleManageAlerts = () => {
    setIsOpen(false)
    openManageAlerts()
  }

  return (
    <>
      <button
        ref={buttonRef}
        className={styles.bellButton}
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <LuBell size={20} />
      </button>

      {isOpen && (
        <div ref={popoutRef} className={styles.popoutContainer}>
          <div className={styles.popoutHeader}>
            <span className={styles.popoutTitle}>Notifications</span>
            <button className={styles.manageAlertsLink} type="button" onClick={handleManageAlerts}>
              <LuSettings size={16} />
              Manage Alerts
            </button>
          </div>
          {/* Will later be expanded into a list of notifications if the API is available */}
          {/* <div className={styles.popoutBody}>No new notifications</div> */}
          <div className={styles.popoutFooter}>
            <button
              className={styles.manageAlertsButton}
              type="button"
              onClick={handleManageAlerts}
            >
              Manage Alerts
            </button>
          </div>
        </div>
      )}
    </>
  )
}
